// Map service type values according to how they are used in plentiful-api
// See https://github.com/PlentifulApp/plentiful-api/blob/development/config/constants.js#L54
export enum ServiceType {
  'line' = 1,
  'reservation' = 2,
  'pre_registration' = 3,
}

export type Visit = {
  id: number;
  pantry_id: number;
  organization_id: number;
  date: number;
  group_id: number;
  time: number;
  until_time: number;
  status: number;
  served_at: number | null;
  service_date: string;
  service_type: ServiceType;
  tefap_attestation: number | null;
  pantry: Partial<Pantry>;
  is_verified: boolean;
  today?: boolean;
  dateTime: string;
};

type TimeSlot = {
  from: number;
  until: number;
  regular: {
    available: number;
    used: number;
  };
  walkin: {
    available: number;
    used: number;
  };
  spaces: number;
};

export type Service = {
  id: number;
  createdAt: string;
  updatedAt: string;
  deleted: boolean;
  pantry_id: number;
  day: number;
  from_time: number;
  until_time: number;
  service_type: ServiceType;
  max_people: number;
  time_interval: number;
  recurring: boolean;
  cancelled: boolean;
  cancelled_block: number;
  service_date: string;
  walk_in_slots_per_group: number;
  service_restriction: string;
  service_block_id: number;
  date: number;
  waiting_list_slots: number;
  service_block_instance_id: number;
  slots: Array<TimeSlot>;
  startTimestamp: number;
  endTimestamp: number;
};

export type ServiceHour = {
  date: string;
  end?: number;
  from?: number;
  time?: number;
  from_time?: number;
  service_date?: string;
  service_type: ServiceType;
  start?: number;
  type: string;
  until: number;
  until_time?: number;
  service_restriction?: string;
  max_people?: number;
  time_interval?: number;
};

export type Pantry = {
  id: number;
  pantry_id: number;
  name: string;
  short_name: string;
  latitude: number;
  longitude: number;
  address: string;
  phone: number;
  website: string;
  city: string;
  state: string;
  zip_code: number;
  email: string;
  notes: string;
  timezone: string;
  advance_registration: number;
  additional_info_confirmed_at: string | null;
  reservations_available_notifications: boolean;
  small_photo_url: string;
  subscribed: boolean;
  auth_code_id: number;
  use_auth_codes: number;
  use_zip_code_restrictions: number;
  restricted_zip_codes: null;
  has_appointment: boolean;
  has_appointments: boolean;
  has_line_open: boolean;
  service_hours: Array<ServiceHour>;
  amenities: Array<string>;
  requested_fields: Array<string>;
  allowed_fields: Array<string>;
  conditions: Array<string>;
  updated_at: string;
  disable_client_booking: boolean;
  use_tefap: boolean;
  frequency_limitations: number;
  frequency_limitations_count: number;
  nextVisit: Visit;
  visits: Array<Visit>;
  new_options: Array<{
    date: string;
    block: Array<Service>;
    blocks: Array<Service>; // TODO: figure out why we have two identical arrays coming from the server, block and blocks
  }>;
  user_can_book: boolean;
  distance: number;
  lastVisit: Visit;
  upcoming: Array<Visit>;
  editable: Array<Visit>;
};
